// deno-lint-ignore-file no-unused-vars
import { h, Fragment } from '../jsx-runtime.ts';
import type { TaskTag, Tag } from '../types.ts';

export function renderTagBadge(tag: TaskTag | Tag): HTMLElement {
  const color = ('tag_color' in tag ? tag.tag_color : tag.color) || '';
  const icon = ('tag_icon' in tag ? tag.tag_icon : tag.icon) || '';
  const name = ('tag_name' in tag ? tag.tag_name : tag.name) || '';

  return <span
    className="tag-badge"
    style={{
      borderColor: color || undefined,
      background: color ? color + '18' : undefined,
    }}
  >{icon ? icon + ' ' : ''}{name}</span> as HTMLElement;
}
